import React, { useState, useEffect } from "react";
import Layout from "../../Components/Layout";
import { SettingsSidebar } from "./SettingsSidebar";
import { UserList } from "./UserList";
import { ThemeList } from "./ThemeList";
import { GdprList } from "./GdprList";
import { SETTINGS_TABS, TabId } from "./SettingsTabs";
import { ChangePasswordModal } from "../../Modals/ChangePasswordModal";

const SettingsPage = () => {
  const [activeTab, setActiveTab] = useState<TabId>("profile");
  const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false);

  useEffect(() => {
    const savedTheme = localStorage.getItem("app-theme") || "teal";
    document.documentElement.setAttribute("data-theme", savedTheme);
  }, []);

  const currentTab =
    SETTINGS_TABS.find((t) => t.id === activeTab) || SETTINGS_TABS[1];

  const renderContent = () => {
    switch (activeTab) {
      case "user":
        return <UserList />;
      case "profile":
        return <div>Φόρμα προφίλ...</div>;
      case "notifications":
        return <div>Ρυθμίσεις ειδοποιήσεων...</div>;
      case "security":
        return <div>Ρυθμίσεις ασφαλείας...</div>;
      case "data":
        return <GdprList />;
      case "theme":
        return <ThemeList />;
      case "change-password":
        return (
          <div className="space-y-4">
            <p className="text-gray-600 text-sm">
              Για την ασφάλεια του λογαριασμού σας, συνιστάται η τακτική αλλαγή του κωδικού πρόσβασης.
            </p>
            <button
              onClick={() => setIsPasswordModalOpen(true)}
              className="px-5 py-2.5 bg-primary text-white rounded-xl font-medium hover:bg-darkprimary transition-colors shadow-sm"
            >
              Αλλαγή Κωδικού Πρόσβασης
            </button>
          </div>
        );
      default:
        return <p>Επιλέξτε μια ενότητα.</p>;
    }
  };

  return (
    <Layout>
      <div className="max-w-5xl mx-auto py-8">
        <h1 className="text-3xl font-bold mb-8">Ρυθμίσεις</h1>
        <div className="flex flex-col md:flex-row gap-8">
          <SettingsSidebar activeTab={activeTab} onTabChange={setActiveTab} />

          <main className="flex-1 bg-white p-8 rounded-xl border border-gray-200 shadow-sm">
            <h2 className="text-xl font-bold mb-6 border-b pb-4">
              {currentTab.label}
            </h2>
            {renderContent()}
          </main>
        </div>
      </div>

      {/* Modal Αλλαγής Κωδικού */}
      <ChangePasswordModal
        isOpen={isPasswordModalOpen}
        onClose={() => setIsPasswordModalOpen(false)}
      />
    </Layout>
  );
};

export default SettingsPage;